import React, { FC, useEffect, useState } from 'react';

import { connect } from 'react-redux';
import CheckoutRevamp from 'src/components/experienceCheckout/CheckoutRevamp';
import CompletedCheckout from 'src/components/experienceCheckout/CompletedCheckout';
import { getPharmacy } from 'src/components/pharmacy/Pharmacy.helpers';
import { IRootReducers } from 'src/reducers';
import {
  IChallengeCheckout,
  IChallengeResourceRender,
  IAddressData,
} from 'src/shared/models';

interface OwnProps extends IChallengeResourceRender {
  config: IChallengeCheckout;
  lengthRequired?: number;
}

const mapStateToProps = (state: IRootReducers) => {
  return { user: state.auth.user };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface ICheckoutData {
  products: number[];
  productsEan?: string[];
  sapCustomerId?: number;
  address?: IAddressData;
}

const ChallengeCheckout: FC<Props> = ({
  config,
  lengthRequired = 1,
  updateChallenge,
  updateUserPoints,
  user,
}) => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [pharmacy, setPharmacy] = useState(null);
  const [showCompletedModal, setShowCompletedModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [checkoutData, setCheckoutData] = useState<ICheckoutData>({
    products: [],
  });

  const { arrProducts, idSelectedProduct, isCompleted, sapCustomerId } = config;

  useEffect(() => {
    if (sapCustomerId) {
      getPharmacy(sapCustomerId).then((res) => setPharmacy(res));
    }
  }, [sapCustomerId]);

  useEffect(() => {
    if (idSelectedProduct) {
      setCheckoutData((prevData) => {
        return {
          ...prevData,
          products: [
            arrProducts.find((item) => item.idResource === idSelectedProduct)
              .idResource,
          ],
        };
      });
    }
  }, [idSelectedProduct]);

  const checkoutComponent = isCompleted ? (
    <CompletedCheckout
      {...{
        config,
        pharmacy,
        setShowCompletedModal,
        showCompletedModal,
      }}
    />
  ) : (
    <CheckoutRevamp
      {...{
        checkoutData,
        config,
        error,
        lengthRequired,
        loading,
        setCheckoutData,
        setError,
        setLoading,
        setShowModal,
        showModal,
        updateChallenge,
        updateUserPoints,
        user,
      }}
    />
  );
  return checkoutComponent;
};

export default connect(mapStateToProps, {})(ChallengeCheckout);
